import { put, takeLatest } from 'redux-saga/effects';
import instance from 'src/sagas/set';
import { HostActionCreators } from 'src/store/reducers/host/action-creators';
import { HostActionEnum } from 'src/store/reducers/host/types';

function* fetchAddAvatar({ id, file }: ReturnType<typeof HostActionCreators.addAvatar>) {
  const formData = new FormData();
  formData.append('image', file);

  try {
    const { status } = yield instance.post(`/host/photo/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    yield put(HostActionCreators.resultAddAvatar(status));
  } catch (e) {
    yield put(HostActionCreators.resultAddAvatar(400));
    console.log(e);
  }
}
export function* actionWatcherAddAvatar() {
  yield takeLatest(HostActionEnum.REQUEST_ADD_AVATAR, fetchAddAvatar);
}
